/**
 * Super Admin Routes Configuration
 * Routes are now centralized in config/CentralizedRoutes.js
 * This file imports routes from centralized configuration
 */
import { CENTRALIZED_ROUTE_MAP } from '../config/CentralizedRoutes';
import { Navigate } from 'react-router-dom';

// Redirect component for root super-admin path
const RedirectToSuperAdminDashboard = () => <Navigate to="/super-admin/dashboard" replace />;

/**
 * Convert centralized route map to React Router route format for super-admin
 */
export const superAdminRoutes = [
  { path: '', element: RedirectToSuperAdminDashboard },
  ...Object.entries(CENTRALIZED_ROUTE_MAP)
    .filter(([routePath]) => routePath.startsWith('/super-admin'))
    .map(([routePath, Component]) => {
      // Remove '/super-admin' prefix for React Router nested routes, preserving dynamic segments
      let path = routePath.replace('/super-admin', '') || 'dashboard';
      // Ensure dynamic routes like :tenantId are preserved
      if (path.startsWith('/')) {
        path = path.substring(1);
      }
      
      // Handle redirects for unified pages with tabs
      if (routePath.includes('/billing/') && routePath !== '/super-admin/billing') {
        const tab = routePath.split('/').pop();
        return {
          path,
          element: () => <Navigate to={`/super-admin/billing?tab=${tab}`} replace />
        };
      }
      
      return {
        path,
        element: Component
      };
    })
];

export default superAdminRoutes;
